import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import ChooseUserPortalDialog from '@/website/components/dialogs/chooseUserPortal/index';
import { useUserPortal } from '@/website/hooks/useUserPortal';
import { goToWebsiteHomePage } from '@/website/util/routes';
import { useAuth0 } from '@auth0/auth0-react';
import { Menu } from '@headlessui/react';
import { Button, DropdownMenu, JoveLogo, jumpToUserPortal, removeAllJoveAppAuthKeys, useLocalTranslation } from '@jove-frontend/uikit';
import { useAuthStore } from '../../store/AuthStore';
import WidgetEmbed from '../WidgetEmbed';
import { CommunityNavbar } from './CommunityNavbar';
import { GetQuoteButton } from './GetQuoteButton';

export const AuthenticatedHeader = () => {
  const { $t } = useLocalTranslation();
  const toggleQuoteModal = () => setIsQuoteModalOpen(true);
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
  const { user, clientPortalUrl } = useAuthStore(({ state }) => state);
  const [showChoosePortalDialog, setShowChoosePortalDialog] = useState(false);
  const { userPortalList } = useUserPortal();
  const router = useRouter();

  /**
   * effects
   */
  useEffect(() => {
    const listener = (e: MessageEvent<string>) => {
      if (e.data === 'close-iframe') {
        setIsQuoteModalOpen(false);
      }
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('message', listener);
    }
    return () => window.removeEventListener('message', listener);
  });

  /**
   * methods
   */
  const goToPortalAction = () => {
    if (userPortalList.length === 1) {
      const item = userPortalList[0];
      jumpToUserPortal(router, item);
    } else {
      setShowChoosePortalDialog(true);
    }
  };

  const closeChoosePortalDialogAction = () => {
    setShowChoosePortalDialog(false);
  };

  const goToHomeAction = () => {
    goToWebsiteHomePage(router);
  };

  return (
    <header className="header">
      <div className="flex justify-between border border-b-black/10 px-10 py-4">
        <div className="flex cursor-pointer items-center" onClick={goToHomeAction}>
          <JoveLogo className="h-7 w-24" />
          <div className="ml-6 h-full w-px bg-black/30"></div>
        </div>

        <div className="flex items-center space-x-4">
          {/* {user && clientPortalUrl && (
            <Button
              color="secondary-outline"
              onClick={() => window.location.replace(clientPortalUrl)}
            >
              <span>Go to Validation Portal</span>
            </Button>
          )} */}
          {userPortalList.length > 0 && (
            <Button color="secondary-outline" onClick={goToPortalAction}>
              <span>{$t('text:navigation.switch_portal')}</span>
            </Button>
          )}

          <UserAvatar />

          <GetQuoteButton openQuoteModal={toggleQuoteModal} />
        </div>
      </div>

      <CommunityNavbar />

      <WidgetEmbed isOpen={isQuoteModalOpen} theme={'default'} />

      {showChoosePortalDialog && <ChooseUserPortalDialog hidePortalListKey={['community-user']} close={closeChoosePortalDialogAction} />}
    </header>
  );
};

const UserAvatar = () => {
  const { logout } = useAuth0();
  const { user } = useAuthStore(({ state }) => state);
  const [loggingOut, setLoggingOut] = useState(false);

  return (
    <div className="flex space-x-1">
      {user && (
        <div className="bg-green-accent flex-shrink-0 rounded-xl p-2 text-center text-sm font-bold text-white">
          {user.first_name?.charAt(0)}
          {user.last_name?.charAt(0)}
        </div>
      )}

      <DropdownMenu label=" ">
        <Menu.Item>
          <Button
            className="w-full"
            color="plain"
            loading={loggingOut}
            disabled={loggingOut}
            onClick={async () => {
              if (loggingOut) return;
              setLoggingOut(true);
              await removeAllJoveAppAuthKeys();
              logout({
                logoutParams: {
                  returnTo: window.location.origin,
                },
              });
            }}
          >
            <span className="inline-block w-full text-left">{loggingOut ? 'Logging out...' : 'Log out'}</span>
          </Button>
        </Menu.Item>
      </DropdownMenu>
    </div>
  );
};
